import { render, staticRenderFns } from "./VehicleLocation.vue?vue&type=template&id=1c84a9aa"
import script from "./VehicleLocation.vue?vue&type=script&lang=js"
export * from "./VehicleLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports